<div class="deviceTypeFilter" placement="right">
  <mat-chip-list>
    <mat-chip *ngFor="let deviceType of deviceTypesForChipFilter index as i "
              [ngClass]="{'selected' : deviceType.value === deviceTypeSelected}"
              (click)="filterList(deviceType.value)"
              [ngbTooltip]="'DEVICE_TYPE_CHIPS' | translate">
      {{deviceType.name | translate}}
    </mat-chip>
    <mat-chip *ngFor="let deviceType of getSelectedDeviceTypeNameForOtherDevices() index as i "
              [ngClass]="{'selected' : deviceType.value === deviceTypeSelected}"
              (click)="filterList(deviceType.value)"
              [ngbTooltip]="'DEVICE_TYPE_CHIPS' | translate">
      {{deviceType.name | translate}}
    </mat-chip>
  </mat-chip-list>
</div>
<div class="deviceTypeFilter" placement="right" style="width:70%"
     [ngStyle]="{'width' : widthInPercent + '%','display': otherDevicesType ? 'initial' : 'none'}" *ngIf="!projectDeviceLocationMode">
  <mat-expansion-panel>
    <mat-expansion-panel-header>
      <mat-panel-title>
        {{'OTHER_DEVICES'|translate}}
      </mat-panel-title>
      <mat-panel-description>
      </mat-panel-description>
    </mat-expansion-panel-header>
    <mat-form-field placement="right" [ngbTooltip]="'SEARCH_INPUT_TOOLTIP' | translate">
      <input matInput value="{{filter}}" (keyup)="applyFilter($event.target.value)"
             [placeholder]="'SEARCH' | translate">
    </mat-form-field>
    <table mat-table [dataSource]="deviceTypeList" matSort class="table-striped"
           style="width:100%">
      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'NAME'|translate}}</th>
        <td mat-cell *matCellDef="let deviceType">
          <mat-chip [ngClass]="{'selected' : deviceType.value === deviceTypeSelected}"
                    (click)="filterList(deviceType.value)"
                    [ngbTooltip]="'DEVICE_TYPE_CHIPS' | translate">{{deviceType.name}}  </mat-chip>
        </td>
      </ng-container>
      <ng-container matColumnDef="description">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>{{'DESCRIPTION'|translate}}</th>
        <td mat-cell *matCellDef="let deviceType">{{deviceType.description}}</td>
      </ng-container>
      <tr mat-header-row *matHeaderRowDef="deviceTypeListColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: deviceTypeListColumns;"></tr>
    </table>
    <mat-paginator [pageSizeOptions]="pageSizeOptions" showFirstLastButtons
                   [pageSize]="5"></mat-paginator>
  </mat-expansion-panel>
</div>
